const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMmEyIDIgMCAwIDEgMiAydjE2YTIgMiAwIDAgMS0yIDJINGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxNnptMCAySDR2MTZoMTZWNHptLTEgMnYxMGgtNHYySDl2LTJINVY2aDE0ek05IDhIN3Y2aDR2Mmgydi0yaDRWOGgtMnYzaC0yVjhoLTJ2M0g5Vjh6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  I as default
};
//# sourceMappingURL=ethernet_on-703e16d4.mjs.map
